import { Component, OnInit, Input, ChangeDetectionStrategy, ElementRef, Renderer } from '@angular/core';
import { Http } from '@angular/http';

@Component({
	selector: 'svg-icon',
	template: `<ng-content></ng-content>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent implements OnInit {

	@Input() name: any = ''
	@Input() classes: any = ''

	constructor(
		private http: Http,
		private renderer: Renderer,
		private elementRef: ElementRef
	) { }

	ngOnInit() {
		if (this.name) {
			this.name = this.name.trim()
			this.loadSvg(this.name);
		}
	}

	loadSvg(val: string) {
		this.http.get(`../../../assets/img/inline/${val}.svg`).subscribe( res => {
			// get our element and clean it out
			const element = this.elementRef.nativeElement;
			element.innerHTML = '';
			// get response and build svg element
			const response = res.text();
			const parser = new DOMParser();
			const svg = parser.parseFromString(response, 'image/svg+xml');
			svg.documentElement.classList.add('c-svgicon')
			svg.documentElement.classList.add('c-svgicon--' + this.name)
			const arr = this.classes.trim().split(' ')
			for (let i = 0; i < arr.length; i++) {
				if (arr[i]) {
					svg.documentElement.classList.add(arr[i].trim())
				}
			}
			// insert the svg result
			this.renderer.projectNodes(element, [svg.documentElement]);
		}, err => {
			console.error(err);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/svg-icon/svg-icon.component.ts